export default __webpack_public_path__ + "static/media/user-white.2f428a28.svg";